<template>
  <div v-show="visible">
    <div class="mask"></div>
    <div class="subject-end">
      <div class="bg-content"></div>
      <div class="dialog-content">
        <p class="title">温馨提示</p>
        <div class="content-body">
          <h2>距离考试结束时间还有10分钟！</h2>
          <div class="option optionTen">
            <a href="javascript:void(0)" class="close" @click="closeDialog">关闭</a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  export default {
    name: 'tenMinutesEnd',
    props: {
      visible: { type: Boolean },
      subFlag: { type: Boolean }
    },
    methods: {
      closeDialog() {
        this.$emit('update:visible', false)
      }
    }
  }
</script>
